export enum ErrorCode {
    InternalServerError = "INTERNAL_SERVER_ERROR",
    UnAuthorizedAccess = "UN_AUTHORIZED_ACCESS",
    SessionExpired = "SESSION_EXPIRED",
    LocalDataMissing = "LOCAL_DATA_MISSING",
    ContactAdmin = "CONTACT_ADMIN",
    SomethingWentWrong = "SOMETHING_WENT_WRONG",
    Forbidden = 'UN_AUTHORIZED_ACCESS',
    NotFound = 'NOT_FOUND',
    UserNotFound = 'USER_NOT_FOUND',
    DB_CONNECTION_FAILED = 'DB_CONNECTION_FAILED',
    NULL_OR_EMPTY = 'NULL_OR_EMPTY',
    SQL_EXEC = 'SQL_EXECUTION',
    NETWORK_ERROR = 'NETWORK_ERROR',
    NO_INTERNET = 'NO_INTERNET',
    GEO_CODE_API_ERROR = 'GEO_CODE_API_ERROR',
    INVALID_DIRECTORY = 'INVALID_DIRECTORY',
    UserPinNotSet = 'USER_PIN_NOT_SET',
    INVALID_VALUE = 'INVALID_VALUE',
    SYNC_FAILED = 'SYNC_FAILED',
    ATT_UP_SYNC_FAILED = 'ATT_UP_SYNC_FAILED',
    ATT_DOWN_SYNC_FAILED = 'ATT_DOWN_SYNC_FAILED',
}